const jQuery = window.jQuery;
import { getUrlParameter, alertCtk } from './utils';
import {
  ajaxUniPost,
  ajaxUniPostUsingCaptcha,
  checkOkStatusInSuccessFunc,
} from './ajaxutils';
import { validateProfilePart } from './validate';
import { loginAndToProfile } from './login';

export function validate() {
  validateProfilePart('resetpass', false);
}
export function validateSilent() {
  validateProfilePart('resetpass', true);
}

export function submitRequestResetPassword(event) {
  console.log('submitting submitRequestResetPassword');
  const data = {};
  const email = jQuery('#formemail').val();
  data.email = email;

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('RequestResetPassword');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };
    if (data.status === 'userNotFound') {
      alertCtk('Zadaný e-mail není registrován');
    } else if (data.status === 'ok') {
      const url = 'pass.php?email=' + email;
      console.log('url: ' + url);
      window.location.assign(url);
    }
  };
  if (email === undefined || email === '' || !email.includes('@')) {
    const url = 'pass.php?cmd=req';
    console.log('url: ' + url);
    window.location.assign(url);
  } else {
    ajaxUniPost('RequestResetPassword', data, successFunc);
  }

  event.preventDefault();
  return false;
}
export function submitDoResetPassword(event) {
  console.log('submitting submitDoResetPassword');
  const data = {};
  const email = jQuery('#formemail').val();
  const code = jQuery('#formresetcode').val();
  const password = jQuery('#formpasswd').val();
  data.email = email;
  data.code = code;
  data.password = password;

  const jsondata = JSON.stringify(data);
  console.log('jsondata: ' + jsondata);

  const successFunc = (result, textStatus, jqXHR) => {
    if (!checkOkStatusInSuccessFunc(result, textStatus, jqXHR)) {
      return false;
    }
    console.log('DoResetPassword');
    const parsed = JSON.parse(result.trim());
    console.log(parsed);
    const data = { ...parsed };
    if (data.status === 'badcredintials') {
      alertCtk(
        'Špatné údaje pro obnovení hesla (buď špatný e-mail, špatný kód, kód po platnosti 24 hodin, nebo už dříve použitý kód)',
      );
    } else if (data.status === 'ok') {
      loginAndToProfile(email, password);
    }
  };
  event.preventDefault();
  ajaxUniPostUsingCaptcha(
    'DoResetPassword',
    data,
    successFunc,
    'resetpassword',
  );

  return false;
}

export function passwordBindHandlers() {
  const vals = ['email', 'passwd', 'passwd2', 'resetcode'];
  vals.forEach((it) => {
    jQuery('#form' + it).on('change paste keyup', validate);
  });

  jQuery('#formrequestresetcode').on('click', submitRequestResetPassword);
  jQuery('#formrequestresetcode2').on('click', submitRequestResetPassword);

  jQuery('#formbuttonresetpassword').on('click', submitDoResetPassword);

  const email = getUrlParameter('email');
  const code = getUrlParameter('code');
  const cmd = getUrlParameter('cmd');
  if (cmd === 'req') {
    jQuery('#phase1').show();
    jQuery('#phase2').hide();
  } else {
    jQuery('#phase1').hide();
    jQuery('#phase2').show();
  }
  if (email) {
    jQuery('#formemail').val(email);
  }
  if (code) {
    jQuery('#formresetcode').val(code);
  }
  validateSilent();
}
